function MapPinIcon({
  size = 36,
  type = 'red',
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  type?: 'red' | 'green';
  className?: string;
  onClick?: (event) => void;
}) {
  const colorPin = type === 'red' ? '#8C363A' : '#2D7455';
  const colorEllipse = type === 'red' ? '#381E26' : '#162A2A';

  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
        <path
          d='M17.5 7.5C17.5 9.91558 14.9493 13.7649 12.8229 16.5542C11.3801 18.4469 8.61991 18.4469 7.17705 16.5542C5.05067 13.7649 2.5 9.91558 2.5 7.5C2.5 3.35786 5.85786 0 10 0C14.1421 0 17.5 3.35786 17.5 7.5Z'
          fill={colorPin}
        />
        <ellipse cx='9.85869' cy='7.32427' rx='2.54717' ry='2.53521' fill={colorEllipse} />
      </svg>
    </span>
  );
}

export default MapPinIcon;
